<d-card>
  <img
    src="https://ciam-cdnendpoint.azureedge.net/testasset01/login.png"
    alt=""
  />

  <div *ngIf="step === 'PasswordCallback'" class="otpMessage">
    <h3>One time authentication</h3>
    <p class="message">Enter the OTP code sent to your email to proceed.</p>
    <p class="strong">Enter code below.</p>
  </div>
  <div id="otp-container" *ngIf="step === 'PasswordCallback'">
    <input
      *ngFor="let digit of otp; let i = index"
      #otpBox
      class="otp-box"
      type="text"
      maxlength="1"
      inputmode="numeric"
      (input)="onInput($event, i)"
      (keydown)="onKeyDown($event, i)"
    />
  </div>
  <div id="widget-root"></div>
</d-card>
